import { render, staticRenderFns } from "./relatedAds.vue?vue&type=template&id=1bb35779&scoped=true"
import script from "./relatedAds.vue?vue&type=script&lang=js"
export * from "./relatedAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb35779",
  null
  
)

export default component.exports